import originals from 'data/copywriting.parsed'

const data = {
  ...originals,
  'en-gb': originals.en,
  'en-za': originals.en,
}

export const copywriting = (locale, path, key = null) => {
  if (!data[locale]) {
    return null
  }

  if (!data[locale][path]) {
    return null
  }

  if (key) {
    if (data[locale][path][key]) {
      return data[locale][path][key]
    } else return null
  }

  return data[locale][path]
}

export default copywriting
